import { render } from "./MeasurementsFields.vue?vue&type=template&id=00dbd3ce&scoped=true"
import script from "./MeasurementsFields.vue?vue&type=script&lang=js"
export * from "./MeasurementsFields.vue?vue&type=script&lang=js"

import "./MeasurementsFields.vue?vue&type=style&index=0&id=00dbd3ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dbd3ce"]])

export default __exports__